import { ModuleFE_PermissionAccessLevel } from './ModuleFE_PermissionAccessLevel.js';
export const ModulePackFE_PermissionAccessLevel = [ModuleFE_PermissionAccessLevel];
//# sourceMappingURL=module-pack.js.map